import {I18nService} from "./i18n.service";
import {TranslateLoader} from "@ngx-translate/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";

export class CombinedTranslateLoader implements TranslateLoader {
    private readonly prefix: string;
    private readonly suffix: string;

    constructor(
        private httpClient: HttpClient,
        private i18nService: I18nService,
        prefix?: string,
        suffix?: string
    ) {
        this.prefix = prefix || './assets/i18n/';
        this.suffix = suffix || '.json';
    }

    getTranslation(lang: string): Observable<any> {
        this.i18nService.loadServerTranslations(lang);
        return this.httpClient.get(`${this.prefix}${lang}${this.suffix}`);
    }
}

/**
 * Factory function to create a CombinedTranslateLoader.
 * Use this in both module-based and standalone apps.
 */
export function createCombinedTranslateLoader(
    http: HttpClient,
    i18nService: I18nService,
    prefix?: string,
    suffix?: string
): TranslateLoader {
    return new CombinedTranslateLoader(http, i18nService, prefix, suffix);
}
